"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELang = void 0;
exports.ELang = {
    FR: "FR",
    EN: "EN",
};
